import React from 'react';
import SmartImage from '../../ui/SmartImage';

function StrukturOrganisasi() {
    return (
        <div className="py-4 lg:py-6">
            <div className="mb-7">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">
                    Organisasi Perusahaan
                </span>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
                    Struktur Organisasi
                </h2>
            </div>

            <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_20px_55px_rgba(15,23,42,0.08)]">
                <div className="h-1.5 bg-gradient-to-r from-[#005da2] via-blue-500 to-cyan-400" />
                <div className="p-3 sm:p-6 lg:p-8">
                    <SmartImage
                        src="/assets-web/struktur-organisasi-2026.png"
                        alt="Struktur Organisasi PT Len Telekomunikasi Indonesia"
                        wrapperClassName="w-full rounded-2xl bg-slate-50"
                        className="block h-auto w-full object-contain"
                    />
                </div>
            </div>
        </div>
    );
}

export default StrukturOrganisasi;
